import { useFloorQuery } from "entities/floors/graphql/queries.generated"
import { useFloorPrice } from "features/floor-management/model/useFloorPrice"
import { useProjectStore } from "features/project-management/model/useProjectStore"

import { AggregatedFloorData } from "../types/AggregatedFloor"

export interface AggregatedFloorDataOptions {
  includePrice?: boolean
  isShared?: boolean
}

export function useAggregatedFloorData({
  floorID,
  projectID,
  options
}: {
  floorID: string
  projectID: string
  options?: AggregatedFloorDataOptions
}): AggregatedFloorData {
  const { pendingElementIDs } = useProjectStore(projectID)
  const isPending = pendingElementIDs.includes(floorID)

  const {
    data: floorData,
    loading: isLoadingFloor,
    error: floorError
  } = useFloorQuery({ variables: { id: floorID } })

  const {
    price,
    isLoading: isLoadingPrice,
    error: priceError
  } = useFloorPrice({
    floorID,
    projectID,
    isPending,
    isShared: options?.isShared
  })

  return {
    floor: {
      data: floorData?.floor ?? null,
      isLoading: isLoadingFloor || isPending,
      error: !!floorError
    },
    price: options?.includePrice
      ? {
          data: price ?? null,
          isLoading: isLoadingPrice,
          error: !!priceError
        }
      : null,
    meta: { isPending }
  }
}
